module.exports = __webpack_public_path__ + "img/engine-home.1417c51a.png";